import styled from "styled-components";

const Wrapper = styled.div`
    font-weight: 900;
    font-size: 22px;
    line-height: 22px;
    user-select: none;
    color: #000;

    > div {
        font-weight: 700;
        font-size: 11px;
        line-height: 11px;
    }
`;

export const Logo = () => {
    return (
        <Wrapper>
            starbatys
            <div>Verwaltung</div>
        </Wrapper>
    );
};
